// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "  .modal-footer button {\n      background-color: #bd207b !important;\n      border-color: #bd207b !important;\n\n  }\n  .modal-footer :hover {\n    background-color: #d91487 !important;\n    border-color: #d91487 !important;\n  }\n\n  .waves-effect waves-light saib-button.is-primary:disabled {\n    border-color: #cccccc !important;\n  }\n\n  .modal-content  h4{\n     color: #bd207b !important;\n\n  }\n", ""]);
// Exports
module.exports = exports;
